module.exports = __webpack_public_path__ + "media/images/webpage/hotels/3105/plan1-1-98e171e1fb2a0c8714392a3f3615aa7a.webp";